import { useMediaQuery } from '@mui/material';

export type ColumnQuery = {
  [key in 'sm' | 'md' | 'lg' | 'xl']: [number, number];
};

export const useColumnCount = (query: ColumnQuery) => {
  const matchesUpSm = useMediaQuery(`(min-width:${query.sm[0]}px)`);
  const matchesUpMd = useMediaQuery(`(min-width:${query.md[0]}px)`);
  const matchesUpLg = useMediaQuery(`(min-width:${query.lg[0]}px)`);
  const matchesUpXl = useMediaQuery(`(min-width:${query.xl[0]}px)`);

  if (matchesUpXl) {
    return query.xl[1];
  } else if (matchesUpLg) {
    return query.lg[1];
  } else if (matchesUpMd) {
    return query.md[1];
  } else if (matchesUpSm) {
    return query.sm[1];
  } else {
    return 1;
  }
};
